import styled from "@emotion/styled";
import { Checkbox } from "@mantine/core";

export const StyledCheckbox = styled(Checkbox)`
  .mantine-Checkbox-body {
    justify-content: space-between;
    padding: 12px;
    border-radius: 4px;
    transition: background-color 0.15s ease;
  }

  .mantine-Checkbox-labelWrapper {
    display: flex;
    flex: 1;
  }

  .mantine-Checkbox-label {
    display: flex;
    cursor: pointer;
  }

  .mantine-Checkbox-input {
    cursor: pointer;
  }
`;
